
import {
  computed,
  defineComponent, inject,
  onUnmounted,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  BOTTOM_POPUP_TYPES,
  NAVIGATION_PAGES,
  PHOTO_VIEW_LAYOUT, PHOTO_VIEW_TYPE,
  SHARE_TYPES,
} from '@/types/enums';
// eslint-disable-next-line import/no-cycle
import { useDriveStore } from '@/modules/drive/store/driveStore';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import AppHeader from '@/components/AppHeader.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
import AuthService from '@/modules/auth/services/AuthService';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';

export default defineComponent({
  components: {
    AppHeader,
    AppSearch,
  },
  setup() {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();
    const router = useRouter();
    const spacesStore = useSpacesStore();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    const searchPlaceholder = computed(() => {
      switch (route.meta?.navigationPage) {
        case NAVIGATION_PAGES.SPACES_CONTACTS:
          return 'contacts.placeholder.search';
        case NAVIGATION_PAGES.SPACES_GROUPS_MAIN:
          return 'groups.placeholder.search';
        default:
          return 'placeholder.search';
      }
    });

    const fullName = computed(() => `${mainStore.user.firstName} ${mainStore.user.lastName}`); // header desktop
    const photoUrl = computed(() => { // header desktop
      if (mainStore.user.photo?.url) {
        return lowResUrlByViewTypeByUrl(mainStore.user.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    const currentPage = computed(() => route.meta.navigationPage);
    function navigateTo(rout: string) {
      router.push(rout);
    }
    function logOut() {
      AuthService.logout().then((response) => {
        if (response.success) {
          router.push('/');
        }
      });
    }

    onUnmounted(() => {
      driveStore.search = '';
    });

    return {
      mainStore,
      driveStore,
      NAVIGATION_PAGES,
      fullName,
      photoUrl,
      BOTTOM_POPUP_TYPES,
      SHARE_TYPES,
      PHOTO_VIEW_LAYOUT,
      router,
      route,
      logOut,
      navigateTo,
      currentPage,
      spacesStore,
      searchPlaceholder,
    };
  },
});
